<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <div class="LineClassPicker">
      <div>
        <van-cell icon="logistics" title="路线" :value="line.text" />
        <van-cell icon="clock-o" title="始发时间" :value="lineClassDay.ClassTime" />
        <van-cell icon="location-o" title="站点" :value="node.NodeName" />
      </div>

      <van-radio-group v-model="checkVehicleGID">
        <van-cell-group inset title="车辆选择">
          <van-cell v-for="item in VehicleList" :key="item.GID"
            :title="item.VehicleNo + '-(' + item.PassengerSeatCount + ')'" clickable @click="checkVehicleGID = item">
            <span v-if="item.NodeIsSignIn">已签到</span>
            <template #right-icon>
              <van-radio :name="item" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <van-button style="margin-top: 1rem;" v-show="checkVehicleGID && !checkVehicleGID.NodeIsSignIn" type="primary"
        block @click="onVehicleClick(1)">站点签到
      </van-button>
      <van-button style="margin-top: 1rem;" v-show="checkVehicleGID && checkVehicleGID.NodeIsSignIn" type="primary"
        block @click="onVehicleClick(2)">取消签到</van-button>

    </div>
  </div>
</template>
  
<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header
  },
  data() {
    return {
      title: "站点签到", //页面标题
      line: JSON.parse(window.localStorage.getItem("line")), //选择的线路
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //选择的班次
      node: JSON.parse(window.localStorage.getItem("lineClassDayStratNode")), //选择的站点

      VehicleList: [], //已派车集合
      checkVehicleGID: null
    };
  },
  watch: {},
  methods: {
    //选中车辆
    onVehicleClick(type) {
      if (type == 1) {
        let params = {
          LineClassDayGID: this.lineClassDay.GID,
          ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
          ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserCode,
          ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserName,
          VehicleGID: this.checkVehicleGID.VehicleGID,
          NodeGID: this.node.NodeGID,
          StatusID: 1,
          SignInInOperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
          SignInInOperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserCode,
          SignInInOperName: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserName,
          SignInInTime: this.$moment().format("YYYY-MM-DD HH:mm")
        };
        this.$http
          .post(this.$api.onNodeSignInCreat, this.$qs.stringify({ _JsonText: JSON.stringify(params) }))
          .then((res) => {
            if (res.success) {
              this.$toast.success("站点签到成功");
              this.checkVehicleGID = null
              setTimeout(() => {
                this.onQueryLineClassDayVehicleDriver()
              }, 500);

            }
          });
      }
      if (type == 2) {
        let params = {
          ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
          ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserCode,
          ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserName,
          GID: this.checkVehicleGID.NodeIsSignIn
        };
        this.$http
          .post(this.$api.onNodeSignInDel, this.$qs.stringify({ _JsonText: JSON.stringify(params) }))
          .then((res) => {
            if (res.success) {
              this.$toast.success("站点取消签到成功");
              this.checkVehicleGID = null
              setTimeout(() => {
                this.onQueryLineClassDayVehicleDriver()
              }, 500);

            }
          });
      }
    },
    //班次车辆数据获取
    onQueryLineClassDayVehicleDriver() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        NodeGID: this.node.NodeGID
      };
      this.$http
        .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
        .then(res => {
          if (res.success) {
            this.VehicleList = res.data;
          }
        });
    }
  },
  mounted: function () {
    this.onQueryLineClassDayVehicleDriver();
  },
  created() { }
};
</script>
  
<style scoped lang="less">
.LineClassPicker {
  width: 95%;
  margin: 10px auto;
  text-align: -webkit-auto;
}

.van-cell__value {
  color: black;
}

.van-cell {
  font-size: 14px;
}

.van-cell__label {
  font-size: 12px;
  color: #323233;
}

.cancelSendCarShow {
  width: 80%;
  height: auto;
  text-align: center;
  font-size: 0.4rem;
  border-radius: 0.2rem;

  .title {
    width: 100%;
    height: 0.86rem;
    line-height: 0.86rem;
    background-color: #eee;
  }

  .content {
    padding: 0.4rem 0;
  }

  .btn {
    width: 100%;
    height: 0.86rem;
    line-height: 0.86rem;
    display: flex;
    justify-content: space-around;
    padding-bottom: 0.4rem;

    button {
      padding: 0 0.4rem;
      color: #fff;
      border-radius: 0.2rem;
    }

    button:first-child {
      background: #2891e7;
    }

    button:last-child {
      background: #ffb870;
    }
  }
}
</style>
  